import type { ClassNameOrFn } from '../types/data-table-class-names';

export function resolveClassName<TContext>(
  classNameOrFn: ClassNameOrFn<TContext> | undefined,
  context: TContext,
): string | undefined {
  if (typeof classNameOrFn === 'function') {
    return classNameOrFn(context);
  }

  return classNameOrFn;
}
